import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
var sortDates = function sortDates(a, b) {
  return a.getTime() - b.getTime();
};
var monthDiff = function monthDiff(d1, d2) {
  if (d1 === undefined || d2 === undefined) {
    return 0;
  }
  d1 = new Date(d1.getFullYear(), d1.getMonth(), 1);
  d2 = new Date(d2.getFullYear(), d2.getMonth(), 1);
  var month = d1.getMonth() - d2.getMonth() + 12 * (d1.getFullYear() - d2.getFullYear());
  return Math.abs(month) + 1;
};
var monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export default {
  name: 'app',
  components: {},
  methods: {
    displayStyle: function displayStyle(iEstStartDate, iEstFinishDate) {
      var estStartDate = moment(iEstStartDate);

      var estFinishDate = moment(iEstFinishDate);

      if (!estStartDate.isValid() || !estFinishDate.isValid()) {
        return { display: 'none' };
      }
      var startDate = moment(this.minDate).add(1, 'M');
      var maxDate = moment(this.maxDate).add(1, 'M');

      var maxDateObj = maxDate.toObject();

      var lastDate = moment(maxDateObj.years + '-' + maxDateObj.months, 'YYYY-MM').daysInMonth();

      var assing = maxDateObj.years + '-' + maxDateObj.months + '-' + lastDate;

      var lastDateOfMonth = moment(assing);

      var startDateObjt = startDate.toObject();
      var sDatecompareString = startDateObjt.years + '-' + startDateObjt.months + '-' + startDateObjt.date;

      var sDateCompate = moment(sDatecompareString);

      var totayDayInGrant = sDateCompate.diff(lastDateOfMonth, 'day') * -1;

      var ratio = 100 / totayDayInGrant;

      var dayInTask = estStartDate.diff(estFinishDate, 'day', true) * -1;
      dayInTask = dayInTask + 1;
      var barWith = dayInTask * ratio;

      var left = estStartDate.toObject().date * ratio;

      return {
        width: barWith + '%',
        left: left + '%'
      };
    },
    displayDate: function displayDate(value, addMonth) {
      var date = new Date(value.getFullYear(), value.getMonth(), 1);
      date.setMonth(date.getMonth() + addMonth);
      return monthArray[date.getMonth()];
    },
    isInMonth: function isInMonth(value, addMonth, projectDate) {
      var date = new Date(value.getFullYear(), value.getMonth(), 1);
      date.setMonth(date.getMonth() + 1 + addMonth);

      var monthString = date.getFullYear() + '-' + ('0' + date.getMonth()).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

      var bebore = moment(monthString).isSameOrAfter(projectDate.estStartDate, 'month');
      var after = moment(monthString).isSameOrBefore(projectDate.estFinishDate, 'month');
      if (bebore && after) {
        return true;
      }
      return false;
    },
    isInMonthAct: function isInMonthAct(value, addMonth, projectDate) {
      if (projectDate.actStartDate == null || projectDate.actFinishDate == null) {
        return false;
      }
      var date = new Date(value.getFullYear(), value.getMonth(), 1);
      date.setMonth(date.getMonth() + 1 + addMonth);

      var monthString = date.getFullYear() + '-' + ('0' + date.getMonth()).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

      var bebore = moment(monthString).isSameOrAfter(projectDate.actStartDate, 'month');
      var after = moment(monthString).isSameOrBefore(projectDate.actFinishDate, 'month');
      if (bebore && after) {
        return true;
      }
      return false;
    }
  },
  props: ['tasks'],
  data: function data() {
    var dateArray = [];
    if (this.tasks === undefined || this.tasks === null || this.tasks.lengh === 0) {
      return dateArray;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(this.tasks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var date = _step.value;

        var f1 = new Date(date.estStartDate);
        f1.setDate(1);
        dateArray.push(f1);
        var f2 = new Date(date.estFinishDate);
        f2.setDate(1);
        dateArray.push(f2);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (dateArray.length === 2) {
      // let firstDate = new Date(dateArray[0])
      // firstDate.setMonth(firstDate.getMonth() - 1)
      // let nextMonth = new Date(dateArray[0])
      // nextMonth.setMonth(nextMonth.getMonth() + 1)
      // dateArray.push(firstDate)
      // dateArray.push(nextMonth)
    }
    dateArray.sort(sortDates);
    return {
      minDate: dateArray[0],
      maxDate: dateArray[dateArray.length - 1],
      totalMonth: monthDiff(dateArray[0], dateArray[dateArray.length - 1]),
      dateArray: dateArray,
      selectedTask: null,
      messages: []
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/grantchart.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/grantchart.vue
// module chunks = 0 1